<mat-expansion-panel [hideToggle]="true" [disabled]="disabled" [(expanded)]="open">
  <mat-expansion-panel-header collapsedHeight="72px" expandedHeight="72px">
    <mat-panel-title>
      @if (open) {
        <img src="assets/default/minus.svg" class="toggle" alt="">
      }
      @if (!open) {
        <img src="assets/default/add.svg" class="toggle" alt="">
      }
      <div class="titles">
        <span class="title">{{getTitle()}}</span>
        @if (subtitle) {
          <span class="subtitle">{{getSubtitle()}}</span>
        }
      </div>
    </mat-panel-title>
    <ng-content select="[header]"></ng-content>
  </mat-expansion-panel-header>

  <ng-content select="[body]"></ng-content>
</mat-expansion-panel>

<!-- Pre loads the minus image as it is sure to be loaded and hides the load time of the image, stopping alignment jitter on panel expansion -->
<div hidden="true">
  <img src="assets/default/minus.svg" alt="">
</div>
